import Vue from 'vue';
import VueRouter from 'vue-router';


Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/components/Dashboard'),
    meta: {
      breadcrumb: [
        { name: 'L&I dashboard' }
      ]
    }
  },
  {
    path: '/property-history',
    name: 'propertyHistory',
    component: () => import('@/layouts/PropertyHistory'),
    meta: {
      breadcrumb: [
        { name: 'L&I dashboard', link: '/' },
        { name: 'Property history' },
      ]
    },
    children: [
      {
        path: 'search',
        name: 'address-search',
        component: () => import('@/views/PropertyHistory/SearchResults'),
        props: route => ({ query: route.query }),
        meta: {
          breadcrumb: [
            { name: 'L&I dashboard', link: '/' },
            { name: 'Property history' },
            { name: 'Search results: ' },
          ]
        },
        children: [
          {
            path: 'building-certification-detail',
            name: 'building-certification-detail',
            component: () => import('@/views/PropertyHistory/DetailViews/BuildingCertificationDetail'),
            props: route => ({ query: route.query}),
            meta: {
              breadcrumb: [
                { name: 'L&I dashboard', link: '/' },
                { name: "Property history", link: '/Property-History'},
                { name: 'Search results: ', detailPage: true},
                { name: 'Certification: ' }
              ]
            },
          },
          {
            path: 'permit-detail',
            name: 'permit-detail',
            component: () => import('@/views/PropertyHistory/DetailViews/PermitDetail'),
            props: route => ({ query: route.query}),
            meta: {
              breadcrumb: [
                { name: 'L&I dashboard', link: '/' },
                { name: "Property history", link: '/Property-History'},
                { name: 'Search results: ', detailPage: true},
                { name: 'Permit: ' }
              ]
            },
          },
          {
            path: 'violation-detail',
            name: 'violation-detail',
            component: () => import('@/views/PropertyHistory/DetailViews/ViolationDetail'),
            props: route => ({ query: route.query}),
            meta: {
              breadcrumb: [
                { name: 'L&I dashboard', link: '/' },
                { name: "Property history", link: '/Property-History'},
                { name: 'Search results: ', detailPage: true},
                { name: 'Violation: ' }
              ]
            },
          },
          {
            path: 'appeal-detail',
            name: 'appeal-detail',
            component: () => import('@/views/PropertyHistory/DetailViews/AppealsDetail'),
            props: route => ({ query: route.query}),
            meta: {
              breadcrumb: [
                { name: 'L&I dashboard', link: '/' },
                { name: "Property history", link: '/Property-History'},
                { name: 'Search results: ', detailPage: true},
                { name: 'Appeal: '}
              ]
            },
          },
          {
            path: 'investigation-detail',
            name: 'investigation-detail',
            component: () => import('@/views/PropertyHistory/DetailViews/ViolationDetail'),
            props: route => ({ query: route.query}),
            meta: {
              breadcrumb: [
                { name: 'L&I dashboard', link: '/' },
                { name: "Property history", link: '/Property-History'},
                { name: 'Search results: ', detailPage: true},
                { name: 'Investigation: '}
              ]
            },
          },
          {
            path: 'business-license-detail',
            name: 'business-license-detail',
            component: () => import('@/views/PropertyHistory/DetailViews/LicenseDetail'),
            props: route => ({ query: route.query}),
            meta: {
              breadcrumb: [
                { name: 'L&I dashboard', link: '/' },
                { name: "Property history", link: '/Property-History'},
                { name: 'Search results: ', detailPage: true},
                { name: 'Business license: ' }
              ]
            },
          },
        ]
      },
      {
        path: 'error',
        name: 'search-error',
        // component: () => import('@/views/PropertyHistory/SearchError'),
        props: true,
        meta: {
          breadcrumb: [
            { name: 'L&I dashboard', link: '/' },
            { name: "Property history", link: '/Property-History'},
          ]
        },
      }
    ],
  },
  {
    path: '/contractor-lookup',
    name: 'contractor-lookup',
    component: () => import('@/layouts/ContractorLookup'),
    meta: {
      breadcrumb: [
        { name: 'L&I Dashboard', link: '/' },
        { name: 'Contractor Lookup' },
      ]
    },
    children: [
      // {
      //   path: 'search',
      //   name: 'contractor-search',
      //   props: route => ({ query: route.query }),
      //   // component: () => import('@/views/ContractorPermitLookup/SearchResults'),
      //   meta: {
      //     breadcrumb: [
      //       { name: 'L&I Dashboard', link: '/' },
      //       { name: 'Contractor Lookup' },
      //       // { name: 'Search Results' },
      //     ]
      //   },
      // },
      {
        path: 'license-violation',
        name: 'contractorLicenseViolation',
        component: () => import('@/views/ContractorLookup/ContractorLicenseViolation'),
        props: route => ({ query: route.query}),
        meta: {
          breadcrumb: [
            { name: 'L&I dashboard', link: '/' },
            {
              name: 'Contractor Lookup',
              link: '/contractor-lookup'
            },
            { name: 'License Violation: ' }
          ]
        },
      },
    ],
  },
  {
    path: '/contractor-permit-lookup',
    name: 'contractorPermitLookup',
    component: () => import('@/layouts/ContractorPermitLookup'),
    meta: {
      breadcrumb: [
        { name: 'L&I Dashboard', link: '/' },
        { name: 'Contractor Permit Lookup' },
      ]
    },
    children: [
      {
        path: 'search',
        name: 'contractorPermitSearch',
        // component: () => import('@/views/ContractorPermitLookup/SearchResults'),
        props: route => ({ query: route.query }),
        meta: {
          breadcrumb: [
            { name: 'L&I dashboard', link: '/' },
            { name: 'Contractor Permit Lookup' },
            { name: 'Contractor Permit Results: ' },
          ]
        },
      },
      {
        path: 'detail',
        name: 'contractorPermitDetail',
        component: () => import('@/views/ContractorPermitLookup/PermitDetail'),
        props: route => ({ query: route.query}),
        meta: {
          breadcrumb: [
            { name: 'L&I dashboard', link: '/' },
            { name: "Contractor Permit Lookup", link: '/contractor-permit-lookup'},
            { name: 'Contractor Permit Results: ', detailPage: true  },
            { name: 'Permit Detail: ', }
          ]
        },
      },
      {
        path: 'error',
        name: 'permit-search-error',
        // component: () => import('@/views/ContractorPermitLookup/SearchError'),
        props: true,
        meta: {
          breadcrumb: [
            { name: 'L&I dashboard', link: '/' },
            { name: "Contractor Permit Lookup", link: '/contractor-permit-lookup'},
          ]
        },
      }
    ],
  },
  {
    path: '/appeals-calendar',
    name: 'appeals-calendar',
    component: () => import('@/layouts/AppealsCalendar'),
    props: route => ({ query: route.query }),
    meta: {
      breadcrumb: [
        { name: 'L&I Dashboard', link: '/' },
        { name: 'Appeals Calendar' },
      ]
    },
    children: [
      {
        path: 'filters',
        name: 'filters',
        // component: () => import('@/layouts/AppealsCalendar'),
        props: route => ({ query: route.query }),
        meta: {
          breadcrumb: [
            { name: 'L&I Dashboard', link: '/' },
            { name: 'Appeals Calendar' },
          ]
        },
      },
      {
        path: 'systemDown',
        name: 'systemDown',
        component: () => import('@/views/AppealsCalendar/SystemDown'),
        meta: {
          breadcrumb: [
            { name: 'L&I Dashboard', link: '/' },
            { name: 'Appeals Calendar'},
          ]
        },
      },
      {
        path: 'appeal',
        name: 'appeal',
        component: () => import('@/views/AppealsCalendar/Appeal'),
        props: route => ({ query: route.query }),
        meta: {
          breadcrumb: [
            { name: 'L&I Dashboard', link: '/' },
            { name: 'Appeals Calendar', detailPage: true  },
            { name: 'Appeal: '},
          ]
        },
      },
    ],
  },
  {
    path: '/zba-appeals-calendar',
    name: 'zba-appeals-calendar',
    component: () => import('@/layouts/AppealsCalendar'),
    props: route => ({ query: route.query }),
    meta: {
      breadcrumb: [
        { name: 'ZBA Appeals Calendar' },
      ]
    },
    children: [
      {
        path: 'filters',
        name: 'filters',
        // component: () => import('@/layouts/AppealsCalendar'),
        props: route => ({ query: route.query }),
        // meta: {
        //   breadcrumb: [
        //     { name: 'L&I Dashboard', link: '/' },
        //     { name: 'ZBA Appeals Calendar' },
        //   ]
        // },
      },
      {
        path: 'systemDown',
        name: 'systemDown',
        component: () => import('@/views/AppealsCalendar/SystemDown'),
        // meta: {
        //   breadcrumb: [
        //     { name: 'L&I Dashboard', link: '/' },
        //     { name: 'ZBA Appeals Calendar'},
        //   ]
        // },
      },
      {
        path: 'appeal',
        name: 'zba-appeal',
        component: () => import('@/views/AppealsCalendar/Appeal'),
        props: route => ({ query: route.query }),
        meta: {
          breadcrumb: [
            { name: 'ZBA Appeals Calendar', detailPage: true  },
            { name: 'Appeal: '},
          ]
        },
      },
    ],
  },
  {
    path: '/zoning-appeal-calendar',
    beforeEnter() {location.href = 'https://www.phila.gov/zba/appeals-calendar'}
  },
  {
    path: '/eclipse-dashboard',
    beforeEnter() {location.href = 'https://eclipse.phila.gov/phillylmsprod/pub/lms/Login.aspx'}
  },
  {
    path: '/permit-application-tracker',
    name: 'PermitApplicationTracker',
    component: () => import('@/layouts/PermitApplicationTracker'),
    props: route => ({ query: route.query }),
    meta: {
      breadcrumb: [
        { name: 'L&I Dashboard', link: '/' },
        { name: 'Permit Application Tracker' },
      ]
    },
  }
];

  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
  });

export default router;
